const locale = {
  placeholder: 'Izvēlieties laiku'
};
export default locale;